import {
  FAQS,
  FOOTER_LINKS,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  REGISTRATION_TERMS_AND_CONDITIONS,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

import GroupInviteBanner from "public/images/oregon/ducks-group.jpg";

const LOGO_URL =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Oregon_Ducks_logo_green.png";
const OrderSummaryDesktopImage =
  "https://ss-leagues.s3.amazonaws.com/NCAA/oregon-bg.png";
const DesktopBannerImage =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Oregon%20Ducks/MKAnight1920x1080.jpg";
const MobileBannerImage =
  "https://ss-leagues.s3.amazonaws.com/NCAA/Oregon%20Ducks/25FB%20Student%20Tickets%20Mobile%20NEW.jpg";

export const oregon_basketball: TTeamConfig = {
  TEAM_SCHEMA: "oregon_basketball",
  TEAM_FULL_NAME: "Oregon Ducks",
  BROWSER_TITLE: "Ducks Basketball Fan Pass",
  CLIENT_ID: "97787f339f16.seasonshare.oregonducks-oregonducks.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#154733",
    COLORS_SECONDARY: "#FEE123",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    FOOTER: {
      LINKS: FOOTER_LINKS,
      BACKGROUND_COLOR: "#154733",
    },

    IS_INTERCOM_ENABLED: true,
    IS_CROWD_HANDLER_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
      SHOW_FAQ_BUTTON: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,
    SHOW_ALL_PASSES_UNDER_BANNER: true,
    DISPLAY_ALL_PASSES_EVENTS: true,
    ORDER_EVENTS_CHRONOLOGICALLY: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: false,
      ATTEND_BUTTON_LABEL: "Request",
      HIDE_TICKET_DELIVERY_STATUS: false,
      HIDE_SEAT_COUNT_MAPPING: { included_with_pass: true },
      CHECK_IN_LABEL: "Request Period",
    },

    ATTEND_EVENT_MODAL: {
      TITLE: "Manage Request",
      DESCRIPTION:
        "By requesting a ticket, you are not guaranteed once for the upcoming game. You will be notified on Monday if you receive a ticket with a link to manage your barcode.",
      ATTEND_BUTTON_LABEL: "Request Ticket",
      ATTEND_BUTTON_ATTENDING_LABEL: "Requested",
      ATTEND_BUTTON_NOT_ATTENDING_LABEL: "Not Requested",
    },

    ADD_ON: {
      CHECKOUT_BUTTON_LABEL: "Claim Tickets",
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTRATION_TERMS_AND_CONDITIONS />,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
      DISABLED_PAYMENT_METHODS: ["AE"],
    },

    ADD_DARK_OVERLAY: true,
    ADD_ONS_LABEL: "Tickets",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL,
    LANDING_PAGE_STATIC_BANNER_URL: DesktopBannerImage,
    ORDER_SUMMERY_BACKGROUND_URL: OrderSummaryDesktopImage,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: MobileBannerImage,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL: GroupInviteBanner.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PRE_PURCHASE_FAQS: FAQS,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
